const currLocation = window.location.href.split('?');
// If href has querystring and it contains the string 'override'
const isValidOverride = () => {
  const validOverride = currLocation.length > 1 && currLocation[1] === 'override';
  const validOverrideSaved = localStorage.getItem('outageOverride') === 'true';

  if (validOverride && !validOverrideSaved) {
    // querystring params are removed after login.
    // save result to localstorage to know if there's a validOverride after login
    localStorage.setItem('outageOverride', 'true');
  }

  return validOverride || validOverrideSaved;
};

export default isValidOverride;
